// extracted by mini-css-extract-plugin
export default {"button":"styles_button__zouPa","fullButton":"styles_fullButton__OShKO"};